import { citypasswordConstants } from "../constants/citypasswordConstants";

const initialState = {
  sending: false,
  citypasswordResponse: {},
  citypasswordList: {},
  deleteStatus: {},
  status: {},
  detail: {},
  error: {},
};

export default function citypasswordReducer(state = initialState, action) {
  switch (action.type) {
    case citypasswordConstants.ADD_CITYPASSWORD_REQUEST:
      return {
        sending: true
      };
    case citypasswordConstants.ADD_CITYPASSWORD_SUCCESS:
      return {
        ...state,
        citypasswordResponse: action.data
      };
    case citypasswordConstants.ADD_CITYPASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case citypasswordConstants.GET_CITYPASSWORD_REQUEST:
      return {
        sending: true
      };
    case citypasswordConstants.GET_CITYPASSWORD_SUCCESS:
      return {
        ...state,
        citypasswordList: action.data
      };
    case citypasswordConstants.GET_CITYPASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case citypasswordConstants.DELETE_CITYPASSWORD_REQUEST:
      return {
        sending: true
      };
    case citypasswordConstants.DELETE_CITYPASSWORD_SUCCESS:
      return {
        ...state,
        deleteStatus: action.data
      };
    case citypasswordConstants.DELETE_CITYPASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case citypasswordConstants.STATUS_CITYPASSWORD_REQUEST:
      return {
        sending: true
      };
    case citypasswordConstants.STATUS_CITYPASSWORD_SUCCESS:
      return {
        ...state,
        status: action.data
      };
    case citypasswordConstants.STATUS_CITYPASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case citypasswordConstants.GET_CITYPASSWORDDETAIL_REQUEST:
      return {
        sending: true
      };
    case citypasswordConstants.GET_CITYPASSWORDDETAIL_SUCCESS:
      return {
        ...state,
        detail: action.data
      };
    case citypasswordConstants.GET_CITYPASSWORDDETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/citypasswordReducer.js